var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-list-item-title',{staticClass:"primary--text text-body-2 font-weight-bold text-center py-2"},[_vm._v(_vm._s(_vm.chartTitle)+" ")]),(!!_vm.modelValue)?_c('div',{staticClass:"chart-container"},[_c('div',{ref:"chart"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }